import React, { useState, useEffect } from "react"
const About = () => {
  const [currentTab, setCurrentTab] = useState("1")
  useEffect(() => {
    setTimeout(() => {
      if (currentTab === "1") {
        setCurrentTab("2")
      } else if (currentTab === "2") {
        setCurrentTab("3")
      } else if (currentTab === "3") {
        setCurrentTab("1")
      }
    }, 5000)
  }, [currentTab])

  return (
    <div className="about-container" id="about">
      <p>
        {currentTab === "1" && (
          <>
            We'll be exploring the power of collaboration, starting with you at
            this event. SOUNDS will bring producers and artists together to
            create moments of <span>collaborate</span> right on the spot.{" "}
          </>
        )}
        {currentTab === "2" && (
          <>
            The producer whose beats artist like the most will{" "}
            <span>win a $1000 prize</span> during SOUNDS underground music
            festival.
          </>
        )}
        {currentTab === "3" && (
          <>
            We'll be doing <span>spontaneous secret giveaways</span> at
            attendees during this event.
          </>
        )}
      </p>
      <div className="tabs-wrapper">
        <button
          onClick={() => setCurrentTab("1")}
          className={currentTab === "1" ? "tabs tabs-active" : "tabs"}
        >
          OVERVIEW
        </button>
        <button
          onClick={() => setCurrentTab("2")}
          className={currentTab === "2" ? "tabs tabs-active" : "tabs"}
        >
          $1000 CHALLENGE
        </button>
        <button
          onClick={() => setCurrentTab("3")}
          className={currentTab === "3" ? "tabs tabs-active" : "tabs"}
        >
          OPEN MIC
        </button>
      </div>
    </div>
  )
}

export default About
